import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=cee90354&scoped=true"
import script from "./CouponItem.vue?vue&type=script&lang=ts"
export * from "./CouponItem.vue?vue&type=script&lang=ts"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=cee90354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee90354",
  null
  
)

export default component.exports